<template>
  <div v-if="ordreTravail">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{  ordreTravail.id
                  ? $t('addEditOrdreTravailTech.title.edit', { code: ordreTravail.code })
                  : $t('addEditOrdreTravailTech.title.add')}}
                <b-tag v-if="getLibelleEtat"
                       type="has-background-subMenu"
                       class="has-text-white mgl-5px">
                  {{ getLibelleEtat }}
                </b-tag>
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <a class="button" @click="retour">
            {{ $t('general.button.cancel') }}
          </a>
          <a class="button is-addOrEdit mgl-10px"
             @click="checkPermissions(constantes.ORDRE_TRAVAIL.maj) ? beforeSave()
                  : showPopUp()">
            {{ $t('general.button.sauvegarder') }}
          </a>
          <a class="button mgl-10px" @click="showAddAttachmentModal()">
            <b-icon icon="paperclip" type="is-default"/>
          </a>
        </div>
      </div>
      <error-msg-component :messages="messages"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           @close="error = $event"/>
      <header-info-ot-patrimoine :ot="ordreTravail" v-if="ordreTravail.otPatrimoine"
                                 :is-detail="false"
                                :is-update="isUpdate"
                                 @deleteOtPatrimoine="ordreTravail.otPatrimoine = null">
      </header-info-ot-patrimoine>
      <div class="tab mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'caracteristique'}"
              @click="activeTab = 'caracteristique'">
            {{ $t('addEditOrdreTravailTech.onglet.caracterique') }}
          </li>
          <li :class="{'is-active': activeTab === 'patrimoine'}"
              @click="activeTab = 'patrimoine'">
            {{ $t('addEditOrdreTravailTech.onglet.patrimoine') }}
          </li>
          <li :class="{'is-active': activeTab === 'demande'}"
              @click="activeTab = 'demande'">
            {{ $t('addEditOrdreTravailTech.onglet.demande') }}
          </li>
          <li :class="{'is-active': activeTab === 'bilan'}"
              @click="activeTab = 'bilan'">
            {{ $t('addEditOrdreTravailTech.onglet.bilan') }}
          </li>
          <li v-if="hasPatrimoine && !isEmplacement"
              :class="{'is-active': activeTab === 'nomenclatureTechnique'}"
              @click="activeTab = 'nomenclatureTechnique'">
            {{ $t('nomenclatureTechnique.title') }}
          </li>
          <li v-if="(isOTImpression || isOTPoseDispositif)
            && moduleStockTiersActive && moduleImpressionActive"
            :class="{'is-active': activeTab === 'lieuDeLivraison'}"
            @click="activeTab = 'lieuDeLivraison'">
            {{ titreOngletLivraison }}
          </li>
        </ul>
      </div>
      <component :is="activeTab"
                 :ordreTravail="ordreTravail"
                 :item="ordreTravail.otPatrimoine"
                 :societeId="ordreTravail.societeId ? ordreTravail.societeId : societeActiveId"
                 :onlyDispositif="isOTImpression"
                 @deleteOtPatrimoine="ordreTravail.otPatrimoine = null"
                 @goToAddDemande="goToAddDemande"
                 @goToUpdatePatrimoine="goToUpdatePatrimoine"
                >
      </component>
    </div>
    <b-modal v-model="popUpPrevention" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('addEditOrdreTravailTech.popUpPrevention.title')"
        :questions="questions"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.valider')"
        @no="popUpPrevention = false"
        @validateQuestions="applyPrevChoices">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import genererOTTech from '@/services/logistique/ordreTravail/tech/genererObject/genererOTTech';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import caracteristique from '@/components/logistique/ordreTravail/tech/addEdit/caracteristique/caracteristique';
import demande from '@/components/logistique/ordreTravail/tech/addEdit/demande';
import bilan from '@/components/logistique/ordreTravail/tech/addEdit/bilan';
import patrimoine from '@/components/logistique/ordreTravail/tech/addEdit/patrimoine/patrimoine';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { get, create, update } from '@/api/logistique/ordreTravailTech';
import messageSucces from '@/services/general/messageSucces';
import preparationEnvoieAuBackOtTech
  from '@/services/logistique/ordreTravail/tech/preparationEnvoieAuBackOtTech';
import transformGetOtTech from '@/services/logistique/ordreTravail/tech/transformGetOtTech';
import { fillInfoOtPatrimoine } from '@/services/logistique/ordreTravail/tech/fillInfoOtPatrimoine';
import translate from '@/services/logistique/ordreTravail/tech/validation/translate';
import validation from '@/services/logistique/ordreTravail/tech/validation/validation';
import validationGeneral from '@/services/validation/validation';
import headerInfoOtPatrimoine
  from '@/components/logistique/ordreTravail/tech/headerInfoOtPatrimoine';
import { LIST_ETAT_OT_TECH } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import {
  DEMONTAGE, MONTAGE, IMPRESSION_AFFICHE,
  DISPOSITIF_FABRIQUE,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import nomenclatureTechnique from '@/components/commun/nomenclature/nomenclatureTechnique';
import genererOtPatrimoine
  from '@/services/logistique/ordreTravail/tech/genererObject/genererOTPatrimoine';
import {
  EMPLACEMENT,
  DISPOSITIF,
  MATERIEL,
  FACE,
} from '@/configuration/gabed/emplacement/emplacementConf';
import lieuDeLivraison from '@/components/logistique/ordreTravail/tech/addEdit/lieuDeLivraison/lieuDeLivraison';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const Attachments = createNamespacedHelpers('attachments');
const Permissions = createNamespacedHelpers('permissions');
const OT = createNamespacedHelpers('ordreTravailTech');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      ordreTravail: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      activeTab: 'caracteristique',
      fromTab: null,
      popUpPrevention: false,
      updatePatrimoine: true,
      questions: [],
      constantes: {
        ORDRE_TRAVAIL,
        IMPRESSION_AFFICHE,
      },
      isUpdate: false,
    };
  },
  components: {
    breadcrumb,
    errorMsgComponent,
    caracteristique,
    demande,
    bilan,
    patrimoine,
    headerInfoOtPatrimoine,
    popUpPrevention,
    nomenclatureTechnique,
    lieuDeLivraison,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...OT.mapGetters({
      otCourant: 'ordreTravailTechCourant',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('addEditOrdreTravailTech.breadcrumb.liste'), route: { name: 'l.logistique.ordre_travail-tech' }, isActive: false },
        { title: this.$t('addEditOrdreTravailTech.breadcrumb.' + (this.ordreTravail.id ? 'edit' : 'add')), route: '', isActive: true },
      ];
    },
    getLibelleEtat() {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === this.ordreTravail.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    isEmplacement() {
      return this.ordreTravail?.otPatrimoine?.emplacementId;
    },
    hasPatrimoine() {
      return this.ordreTravail?.otPatrimoine;
    },
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    isOTImpression() {
      return this.typesOT
        .find((t) => t.id === this.ordreTravail?.typeOtId)
        ?.actionInterventionOt === IMPRESSION_AFFICHE;
    },
    isOTPoseDispositif() {
      return this.typesOT.find((t) => t.id === this.ordreTravail?.typeOtId)
        ?.actionInterventionOt === DISPOSITIF_FABRIQUE;
    },
    titreOngletLivraison() {
      if (this.isOTPoseDispositif) {
        return this.$t('addEditOrdreTravailTech.onglet.adresseLivraison');
      }
      return this.$t('addEditOrdreTravailTech.onglet.lieuDeLivraison');
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...OT.mapActions({
      setOtCourant: 'setOtCourant',
    }),
    goToUpdatePatrimoine() {
      this.setOtCourant(this.ordreTravail);
      this.ordreTravail.isFromPatrimoine = true;
      this.$router.push({ name: 'm.logistique.ordre_travail-techAddPatrimoine' });
    },
    goToAddDemande() {
      this.setOtCourant(this.ordreTravail);
      this.ordreTravail.isFromDemande = true;
      this.$router.push({ name: 'm.logistique.ordre_travail-techAddDemande' });
    },
    beforeSave() {
      this.questions = [];
      const typeOt = this.parametre(PARAMETRES_KEYS.typeOt)
        .find((t) => t.id === this.ordreTravail.typeOtId);
      if (typeOt.actionInterventionOt !== this.constantes.IMPRESSION_AFFICHE) {
        this.ordreTravail.campagneId = null;
      }
      if (!typeOt) {
        this.save(false);
        return;
      }
      if (!this.ordreTravail.id && (typeOt.actionInterventionOt === MONTAGE
        || typeOt.actionInterventionOt === DEMONTAGE)) {
        this.questions = [{
          key: 0,
          value: true,
          message: typeOt.actionInterventionOt === MONTAGE
            ? 'addEditOrdreTravailTech.popUpPrevention.actionMontage'
            : 'addEditOrdreTravailTech.popUpPrevention.actionDemontage',
        }];
        this.popUpPrevention = true;
      } else this.save(false);
    },
    applyPrevChoices(values) {
      let updatePatrimoine = false;
      if (!values || values.length === 0) this.save(false);
      values.forEach(v => {
        if (v.key === 0) updatePatrimoine = v.value;
      });
      this.save(updatePatrimoine);
    },
    async save(updatePatrimoine) {
      const loadingComponent = this.$buefy.loading.open();
      const otToSave = preparationEnvoieAuBackOtTech(cloneDeep(this.ordreTravail));
      try {
        let idOt = null;
        if (otToSave?.otPatrimoine?.nomenclature) {
          otToSave.otPatrimoine.nomenclature = (
            JSON.stringify(otToSave.otPatrimoine.nomenclature));
        }
        if (this.$route.params.id) {
          idOt = (await update(otToSave)).data.result;
          await this.updateAttachments(idOt);
          messageSucces(this.$i18n.t('addEditOrdreTravailTech.messages.success.update'));
        } else {
          otToSave.societeId = this.societeActiveId;
          otToSave.updatePatrimoine = updatePatrimoine;
          idOt = (await create(otToSave)).data.result;
          await this.insertAttachments(idOt);
          messageSucces(this.$i18n.t('addEditOrdreTravailTech.messages.success.create'));
        }
        await this.$router.push({ name: 'c.logistique.ordre_travail-tech', params: { id: idOt } });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    genererOtTechAndfillAgence() {
      const ot = genererOTTech();
      if (this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === this.utilisateur.agenceId;
      })) {
        ot.agenceId = this.utilisateur.agenceId;
      } else ot.agenceId = this.agencesSelectionnees[0].agenceId;
      return ot;
    },
    gestionOtPatrimoine(patrimoineId, type) {
      const otPatrimoine = genererOtPatrimoine();
      switch (type) {
        case FACE:
          otPatrimoine.faceId = patrimoineId;
          break;
        case EMPLACEMENT:
          otPatrimoine.emplacementId = patrimoineId;
          break;
        case MATERIEL:
          otPatrimoine.materielId = patrimoineId;
          break;
        case DISPOSITIF:
          otPatrimoine.dispositifId = patrimoineId;
          break;
        default:
          break;
      }
      return otPatrimoine;
    },
    retour() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push({ name: 'l.logistique.ordre_travail-tech' });
    },
    parserNomenclature(otPatrimoine) {
      if (otPatrimoine.nomenclature) {
        otPatrimoine.nomenclature = JSON.parse(otPatrimoine.nomenclature);
      }
      return otPatrimoine;
    },
    ordreTravailTags() {
      const { tags: otTags } = this.ordreTravail;
      return otTags.map((otTag) => ({
        ...otTag,
        tag: this.parametre(PARAMETRES_KEYS.tag).find((tag) => tag.id === otTag.tagId),
      }));
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt, PARAMETRES_KEYS.tag]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      if (this.otCourant) {
        this.ordreTravail = this.otCourant;
        if (this.ordreTravail.isFromPatrimoine) this.activeTab = 'patrimoine';
        if (this.ordreTravail.isFromDemande) this.activeTab = 'demande';
        this.ordreTravail.isFromPatrimoine = false;
        this.ordreTravail.isFromDemande = false;
        this.setOtCourant(null);
      } else if (this.$route.params.id) {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        await this.setAttachmentElementId({ id: this.$route.params.id });
        const ordreTravail = (await get(this.$route.params.id)).data.result;
        await fillInfoOtPatrimoine(ordreTravail.otPatrimoine, true);
        this.ordreTravail = transformGetOtTech(ordreTravail);
        this.isUpdate = true;
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.ordreTravail.code }));
      } else if (this.$route.params.patrimoineId && this.$route.params.typePatrimoine) {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        this.ordreTravail = this.genererOtTechAndfillAgence();
        const otPatrimoine = this.gestionOtPatrimoine(this.$route.params.patrimoineId,
          this.$route.params.typePatrimoine);
        await fillInfoOtPatrimoine(otPatrimoine, false);
        this.ordreTravail.otPatrimoine = otPatrimoine;
        if (this.$route.params.ligneId) {
          this.ordreTravail.affectationsTechniquesLignesCommandeIds = [this.$route.params.ligneId];
        }
        this.setInformationPage(this.$t('pageLogistique.ot.creationOtTech'));
      } else {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        this.ordreTravail = this.genererOtTechAndfillAgence();
        this.setInformationPage(this.$t('pageLogistique.ot.creationOtTech'));
      }
      if (this.ordreTravail.otPatrimoine) {
        this.ordreTravail.otPatrimoine = this.parserNomenclature(this.ordreTravail.otPatrimoine);
      }
      this.ordreTravail.tags = this.ordreTravailTags();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>
